/* Двери notifications.inbox через Хаб (дверь §5.1 спеки 2026-09-20-notifications.md):
   GET /api/notifications, POST /api/notifications/dismiss, POST /api/notifications/seen,
   GET /api/notifications/history, GET /api/notifications/sources. Бэкенд отдаёт key+params —
   видимый текст строит фронт словарём (t(key, params)), заголовков/тел с бэка больше нет. */
import { apiFetch } from "./client";
// paramsToArgs — params бэка приходит произвольным JSON-объектом (интерполяция t());
// структурные объекты (tag/yesno/poll/rating — см. annFieldsFromParams) в интерполяции смысла
// не имеют, пропускаем их здесь, иначе String(object) засорил бы текст «[object Object]».
function paramsToArgs(raw) {
    if (!raw || typeof raw !== "object" || Array.isArray(raw))
        return {};
    const out = {};
    for (const [k, v] of Object.entries(raw)) {
        if (v !== null && typeof v === "object")
            continue;
        out[k] = typeof v === "number" ? v : String(v);
    }
    return out;
}
// annFieldsFromParams — структурные поля объявления из params (общие и для REST, и для кадра
// живого канала — buildFrameParams кладёт их одинаково в обоих местах).
export function annFieldsFromParams(raw) {
    const out = {};
    if (!raw || typeof raw !== "object" || Array.isArray(raw))
        return out;
    const p = raw;
    if (typeof p.title === "string" && p.title)
        out.title = p.title;
    if (typeof p.kind === "string" && p.kind)
        out.kind = p.kind;
    if (p.tag && typeof p.tag === "object") {
        const t = p.tag;
        if (typeof t.label === "string" && typeof t.color === "string")
            out.tag = { label: t.label, color: t.color };
    }
    if (typeof p.required === "boolean")
        out.required = p.required;
    if (typeof p.confirmLabel === "string" && p.confirmLabel)
        out.confirmLabel = p.confirmLabel;
    if (typeof p.closesAt === "string")
        out.closesAt = p.closesAt;
    if (p.yesno && typeof p.yesno === "object") {
        const y = p.yesno;
        out.yesno = { yes: typeof y.yes === "string" ? y.yes : undefined, no: typeof y.no === "string" ? y.no : undefined };
    }
    if (p.poll && typeof p.poll === "object") {
        const pl = p.poll;
        const options = Array.isArray(pl.options)
            ? pl.options
                .filter((o) => !!o && typeof o === "object")
                .map((o) => ({ id: String(o.id ?? ""), label: String(o.label ?? "") }))
            : [];
        out.poll = {
            options,
            multi: !!pl.multi,
            anonymous: !!pl.anonymous,
            quiz: !!pl.quiz,
            correct: Array.isArray(pl.correct) ? pl.correct.map(String) : undefined,
        };
    }
    if (p.rating && typeof p.rating === "object") {
        const rt = p.rating;
        if (typeof rt.scale === "number") {
            out.rating = { scale: rt.scale, low: typeof rt.low === "string" ? rt.low : undefined, high: typeof rt.high === "string" ? rt.high : undefined };
        }
    }
    return out;
}
function fromRaw(raw) {
    return {
        id: raw.id,
        sourceSlug: raw.source_slug,
        key: raw.key,
        params: paramsToArgs(raw.params),
        deepLink: raw.deep_link,
        annId: raw.ann_id,
        createdAt: raw.created_at,
        ...annFieldsFromParams(raw.params),
    };
}
export async function fetchNotifications(opts = {}) {
    const q = new URLSearchParams();
    if (opts.limit)
        q.set("limit", String(opts.limit));
    if (opts.cursor)
        q.set("cursor", opts.cursor);
    const qs = q.toString();
    const res = await apiFetch(`/api/notifications${qs ? `?${qs}` : ""}`);
    return { items: (res.items ?? []).map(fromRaw), nextCursor: res.next_cursor, unread: res.unread };
}
export async function dismissNotifications(target) {
    const body = Array.isArray(target) ? { ids: target } : { all: true };
    const res = await apiFetch("/api/notifications/dismiss", { method: "POST", body });
    return { unread: res.unread };
}
export async function markNotificationsSeen() {
    const res = await apiFetch("/api/notifications/seen", { method: "POST" });
    return { unread: res.unread };
}
export async function fetchNotificationHistory(filter = {}) {
    const q = new URLSearchParams();
    if (filter.source)
        q.set("source", filter.source);
    if (filter.from)
        q.set("from", filter.from);
    if (filter.to)
        q.set("to", filter.to);
    if (filter.cursor)
        q.set("cursor", filter.cursor);
    if (filter.limit)
        q.set("limit", String(filter.limit));
    const qs = q.toString();
    const res = await apiFetch(`/api/notifications/history${qs ? `?${qs}` : ""}`);
    return { items: (res.items ?? []).map(fromRaw), nextCursor: res.next_cursor };
}
export async function fetchNotificationSources() {
    const res = await apiFetch("/api/notifications/sources");
    return res.sources ?? [];
}
// answerAnnouncement — ответ на объявление ANN-V2 (опрос/да-нет/оценка/подтверждение), та же дверь
// продукта «Объявления», которой зовёт сам продукт (/m/notifications/api/ann/*): конверт отказа
// {error:{code}} приходит через apiFetch как ApiError с кодом/локализованным текстом по err.<code>.
export async function answerAnnouncement(annId, value) {
    await apiFetch(`/m/notifications/api/ann/my/${annId}/answer`, { method: "POST", body: { value } });
}
